$(document).ready(function() {
	//Mobile Navigation
	$("#mmenu").mmenu();

	//Lightbox
	$(".cboxElement").colorbox({
		loop: true,	
		rel:'group',
		maxWidth: '95%',
		maxHeight: '95%'
	});

	//Sticky Elements
	$('.fixt').fixTo('.fixit', {mind:'.header-status-fix'}); 

	var $touch = "body.win-ce .menu li.submenu,body.ios .menu li.submenu,body.android .menu li.submenu,body.blackberry .menu li.submenu";
	$($touch).on("touchstart", function (e) {
	    "use strict"; //satisfy the code inspectors 
	    var link = $(this); //preselect the link
	    if (link.hasClass('hover')) { 
	        return true;
	    } else {
	        link.addClass("hover");
	        $($touch).not(this).removeClass("hover");
	        e.preventDefault();
	        return false; //extra, and to make sure the function has consistent return points
	    }
	});
	
	
    /**
     * LOGIN PASSWORD TOGGLE
     */
    var accountSwitch = function (type) {
		console.log('called accountSwitch');
        type = type || 'register';
        jQuery('.visible-switch-account').show();
        switch (type) {
            case 'register':
                jQuery('.visible-guest-account').hide();
                break;
            default:
                jQuery('.visible-register-account').hide();
        }
    };
    jQuery('#guest-account')
        .change(function () {
            accountSwitch(jQuery(this).val());
        });


    /**
     * HEADER BOX schließen/öffnen
     */
	jQuery('body')
		.on('click','.button-quick-box',function(event){ 
			event.stopPropagation();
			showCartBox($(this));
	        event.preventDefault();
		});

	jQuery('body')
		.click(function handler(event) {
			var openBox = jQuery('body').find('.quick-box');
			if (!$(event.target).closest('.quick-box').hasClass('open')) {
		       hideCartBox(); 
			}
		});

});